/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteForgotPwdCtrl',["$log","$scope","$rootScope","$routeParams","Auth","CustomerSrv","CustomerView","CustomerData","WebPreLoaderData","Constants",
        function($log,$scope,$rootScope,$routeParams,Auth,CustomerSrv,CustomerView,CustomerData,WebPreLoaderData, Constants) {
            $scope.dd = {
                view : {
                    waitServerResponse : false,
                    mailSent : false,
                    mailNotSent : false,
                    errorMessage : null
                }
            }

        $scope.$watch('ad.view.loaded', function(newValue, oldValue) {
            if (newValue)
            {
                if ($routeParams.token && $routeParams.email)//received change pwd request
                {
                    Auth.loginToWebSiteByToken($routeParams.email,WebPreLoaderData.companyCode,$routeParams.token);
                    CustomerSrv.getByEmail($routeParams.email,function (customer) {
                        if (!$scope.ad.view.customerView) {
                            $scope.ad.view.customerView = new CustomerView(customer,CustomerData.getIndexOf(customer),$scope);
                            $scope.ad.view.customerView.initCustomerHistoryDatas(customer);
                        }
                        $scope.ad.customerConnected = true;
                    },function () { //error
                        //remove cookie and login Anonymous
                        Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                        $scope.loginAnonymous();
                    })
                }
            }
        });

        $scope.afterSaveSuccess = function(customer)
        {
            $scope.dd.view.waitServerResponse = false;
            console.log("afterSaveSuccess")
            console.log(customer)
            if (customer!=null)
            {
                $scope.ad.view.customerView.password = null;//hide by security
                $scope.ad.view.customerView.passwordAgain = null;//hide by security
                $scope.ad.view.customerView.currentPassword = null;//hide by security
                $scope.ad.view.customerView.loadDataFrom(customer);
                $scope.openLocation('account');

            }

        }
        $scope.afterSaveError = function(errorCode,errorMessage)
        {
            console.log(errorMessage);
            $scope.dd.view.errorMessage = errorMessage;
            $scope.dd.view.waitServerResponse = false;

        }
        $scope.changePwd  = function()
        {
            console.log("changePwd")
            console.log($scope.ad.view.customerView)
            if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse)
                if ($scope.ad.view.customerView.canChangePwdOnWeb!== undefined && $scope.ad.view.customerView.canChangePwdOnWeb())
                {
                    $scope.dd.view.waitServerResponse = true;
                    let customer = $scope.ad.view.customerView.getModel();
                    $scope.ad.view.customerView.copyDataTo(customer);
                    CustomerSrv.changePwd(customer,$scope.afterSaveSuccess,$scope.afterSaveError);
                }
                else
                    $scope.dd.view.displayError = true;
        };

        $scope.forgotPwd = function()
        {
            if ($scope.ad.view.customerView && $scope.ad.view.customerView.email && $scope.ad.view.customerView.email != "") {
                let emailVerification = $scope.validateEmailFormat($scope.ad.view.customerView.email);
                if (emailVerification) {
                    $scope.dd.view.waitServerResponse = true;
                    CustomerSrv.forgotPwd($scope.ad.view.customerView.email,
                        function () {
                            $scope.dd.view.waitServerResponse = false;
                            $scope.dd.view.mailSent = true;
                            $scope.dd.view.errorMessage = null;
                        },
                        function (message) {
                            $scope.dd.view.waitServerResponse = false;
                            $scope.dd.view.mailNotSent = true;
                            $scope.dd.view.errorMessage = message;
                        }
                    );
                }
            }
        };

        $scope.validateEmailFormat = function (email) {
            let regex = new RegExp(Constants.EMAIL, 'i');
            return regex.test(email);
        }

    }]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteForgotPwdCtrl.js